import { render } from "./TimestampTags.vue?vue&type=template&id=6582427c"
import script from "./TimestampTags.vue?vue&type=script&lang=js"
export * from "./TimestampTags.vue?vue&type=script&lang=js"

import "./TimestampTags.vue?vue&type=style&index=0&id=6582427c&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__